import React from 'react'

export const toggleTheme = () => {
  let body = document.getElementsByTagName('body')[0]
  body.setAttribute('data-layout-color', 'dark')
  body.setAttribute('data-leftbar-theme', 'dark')
}

export const showDialog = () => {
  const body = document.body;
  body.style.overflowY = 'hidden';
};

export const closeDialog = () => {
  const body = document.body;
  body.style.overflowY = '';
}
